import { atom } from "jotai";
import {
  emitEventOnModifyPromptAtom,
  showAIStreamCreateModalAtom,
  togglesAtomResettable,
} from "@zapier/canvas-state";
import { isModifyPromptOpenAtom } from "./isModifyPromptOpenAtom";

export const handleModifyPromptCommand = atom(null, (get, set) => {
  const toggles = get(togglesAtomResettable);

  if (toggles.showModifyPrompt) {
    set(isModifyPromptOpenAtom, true);
  } else {
    set(showAIStreamCreateModalAtom, true);
  }

  set(emitEventOnModifyPromptAtom);
});

handleModifyPromptCommand.debugLabel = "handleModifyPromptCommand";
